export const DATA_SKILLS = [
  { nom: "NumPy",        image: "/assets/img/icon/stack/numpy.svg" },
  { nom: "Pandas",       image: "/assets/img/icon/stack/pandas.svg" },
  { nom: "Matplotlib",   image: "/assets/img/icon/stack/matplotlib.svg" },
  { nom: "Seaborn",      image: "/assets/img/icon/stack/seaborn.svg" },
  { nom: "Scikit-learn", image: "/assets/img/icon/stack/sklearn.svg" },
  { nom: "Power BI",     image: "/assets/img/icon/stack/powerbi.webp" },
];
